"use client";

import { $api } from "@/lib/api-client";
import type { components } from "@/types/api";

type PrepareOrderResponseDto = components["schemas"]["PrepareOrderResponseDto"];

type UseOrderPrepareOptions = {
  onSuccess?: (data: PrepareOrderResponseDto) => void;
  onError?: (error: Error) => void;
};

/**
 * Hook to prepare an order for NFT minting
 * Calls POST /order/prepare to pre-generate NFT metadata and get token_uris
 *
 * Flow:
 * 1. Call this mutation before blockchain minting
 * 2. Use the returned token_uris for NFT minting
 * 3. Pass preparation_id when creating the final order
 *
 * Note: Preparation expires after 15 minutes
 */
export const useOrderPrepare = (options?: UseOrderPrepareOptions) => {
  return $api.useMutation("post", "/order/prepare", {
    onSuccess: (response) => {
      if (response?.data && options?.onSuccess) {
        options.onSuccess(response.data);
      }
    },
    onError: (error: unknown) => {
      if (options?.onError) {
        const errorObj =
          error instanceof Error ? error : new Error("Failed to prepare order");
        options.onError(errorObj);
      }
    },
  });
};
